
import {
  Box,
  Button,
  FormLabel,
  Grid,
  GridItem,
  Select,
  Text,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { generateValidationSchema } from "services/Crm/utils";
import CustomForm from "common/utils/customForm";
import * as yup from "yup";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import { getApi } from "common/services/api";
import { globalStyles } from "common/theme/styles";
import { useNavigate } from "react-router-dom";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import CreateTabs from "common/components/createTabs";

const ContactInformation = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // const initialFieldValues = Object.fromEntries(props?.contactData?.fields?.map(field => [field.name, '']))
  const initialFieldValues = Object.fromEntries(
    (props?.contactData?.fields || []).map((field) => [field?.name, ""])
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    ...initialFieldValues,
    createBy: JSON.parse(localStorage.getItem("user"))._id,
  };

  const formik = useFormik({
    // initialValues: initialValues,
    // validationSchema: contactSchema,
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: yup
      .object()
      .shape(generateValidationSchema(props?.contactData?.fields)),
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });

  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  const AddData = async () => {

    try {
      setIsLoading(true);
      let response = await postApi("api/form/add", {
        ...values,
        moduleId: props?.contactData?._id,
      });
      if (response.status === 200) {
        // props.setAction((pre) => !pre);
        toast.success(crmConstant.contactAddedSuccessfully);
        navigate("/crm/contacts");
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
      resetForm();
    }
  };
  const handleBackPage = () => {
    navigate("/crm/contacts");
  };

  return (
    <>
      <Box className="commonPanelBody">
        <CustomForm
          moduleData={props.contactData}
          values={values}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
        />
        {/* <Grid templateColumns="repeat(2, 1fr)" gap={3} mt={2}>
          <GridItem colSpan={{ base: 2 }} paddingTop={1}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.asignToLead}<span style={{ color: "red" }}>*</span>
            </FormLabel>
            <Select
              value={values.assignmentToLead}
              name="assignmentToLead"
              onChange={handleChange}
              mb={
                errors.assignmentToLead && touched.assignmentToLead
                  ? undefined
                  : "10px"
              }
              fontWeight="500"
              placeholder={constant.select}
              borderColor={
                errors.assignmentToLead && touched.assignmentToLead
                  ? "red.300"
                  : null
              }
            >
              {props.leadList &&
                props.leadList.length > 0 &&
                props.leadList?.map((item) => {
                  return (
                    <option value={item._id} key={item._id}>
                      {item.leadName}
                    </option>
                  );
                })}
            </Select>
            <Text
              mb="5px"
              color={"red"}
              fontSize="sm"
              textTransform={"capitalize"}
            >
              {" "}
              {values.assignmentToLead === "" && isSubmitting
                ? crmConstant.leadErrorMsg
                : null}
            </Text>
          </GridItem>
        </Grid> */}
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          sx={{ textTransform: "capitalize" }}
          variant="brand"
          disabled={isLoading ? true : false}
          assignmentToLead="submit"
          size="sm"
          onClick={() => {
            setIsSubmitting(true);
            handleSubmit();
          }}
          className="theme-btn1"
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {crmConstant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateContact = () => {
  const [contactData, setContactData] = useState([]);

  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate("/crm/contacts");
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const tabsData = [{ label: crmConstant.contactInformation, Icon: JobOpeningIcon }];

  const panelsData = [
    <ContactInformation contactData={contactData[0]} />,
  ];

  useEffect(() => {
    (async () => {
      const result = await getApi(`api/custom-field/?moduleName=Contacts`);
      setContactData(result?.data);
    })();
  }, []);



  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createContact}
    />
  );
};

export default CreateContact;
